import { render } from "./WhitepaperTokenomics.vue?vue&type=template&id=4ae60107&scoped=true"
const script = {}

import "./WhitepaperTokenomics.vue?vue&type=style&index=0&id=4ae60107&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae60107"]])

export default __exports__